import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Stories from '../views/Stories.vue'
import Birds from '../views/Birds.vue'
import Plants from '../views/Plants.vue'
import About from '../views/About.vue'
import Login from '../views/Login.vue'
import Photos from '../views/Photos.vue'
import firebase from '@/plugins/firebase'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: '/stories',
      name: 'stories',
      component: Stories,
      meta: { requiresAuth: true }
    },
    {
      path: '/birds',
      name: 'birds',
      component: Birds,
      meta: { requiresAuth: true }
    },
    {
      path: '/plants',
      name: 'plants',
      component: Plants,
      meta: { requiresAuth: true }
    },
    {
      path: '/photos',
      name: 'photos',
      component: Photos,
      meta: { requiresAuth: true }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      redirect: '/login'
    },
  ]
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(r => r.meta.requiresAuth)
  if (requiresAuth && !await firebase.getCurrentUser()) {
    next('login')
  } else {
    next()
  }
})

export default router
